var ProlookSaveDesign = {
    "cartItemApi" : {},
    "cartItemSide2Api" : {},
    "prolookApi" : {},
    "rosterApi" : {},
    "cartApi": {},
};

ProlookSaveDesign.events = {
    calledOnceFunctions: [],

    initialize: function() {
        var CART_HOST_ORIGIN = location.origin;
        var PL_API_HOST_ORIGN = ub.config.api_host;

        ProlookSaveDesign.cartItemApi = new CartItemApi(CART_HOST_ORIGIN);
        ProlookSaveDesign.rosterApi = new RosterAPI(CART_HOST_ORIGIN);
        ProlookSaveDesign.cartItemSide2Api = new CartItemSide2Api(CART_HOST_ORIGIN);
        ProlookSaveDesign.prolookApi = new ProlookApi(PL_API_HOST_ORIGN);
        ProlookSaveDesign.cartApi = new CartApi(CART_HOST_ORIGIN);

        ProlookSaveDesign.events.bindEvents();

        // add `materialId` param in my-saved-design url
        // for reference only by backend team
        ProlookSaveDesign.events.addMaterialIdUrlParams();
    },

    bindEvents: function() {
        $("#save-and-continue").click( function() {
            var colorConflictTextApplication = ub.funcs.textApplicationWithColorConflict();
            var colorConflictEmbellishment = ub.funcs.embellishmentsWithColorConflict();
            var colorConflictParts = ub.funcs.materialOptionsWithColorConflict();

            // trigger Team Flag mirror image
            ProlookSaveDesign.funcs.triggerTeamFlagMirrorImage();

            // conflict applications;
            if (_.size(colorConflictEmbellishment) > 0 || colorConflictParts.length > 0 || colorConflictTextApplication.length > 0) {
                ProlookSaveDesign.utilities.showConflictColorModal();
                return undefined;
            }

            // Show Saving Popup Options
            if(_.isNull(ub.user.cart_item_id)) {
                // show notif on builder if single ply reversible design is loaded
                let INVALID_REVERSIBLE = !ProlookReversible.funcs.isValidReversible();
                if (INVALID_REVERSIBLE) { 
                        ProlookReversible.funcs.showNotifOnSaveAndContinueBtn();
                        return;
                }

                // Show cart lists
                if (localStorage.getItem('reversibleFromSavedDesign') === "1") {
                    CartInformation.events.onShowCartsListReversibleSavedDesign();
                    return;
                } else {
                    CartInformation.events.onShowCartsList();
                    return;
                }
            }

            var onReversibleSide2 = _.isEqual(ub.config.isEmbedded, "1");
            var parentWindow = window.parent;

            parentWindow.Loader.customizer.saving({stack: true});
            parentWindow.Loader.loading(1, 9);

            if (onReversibleSide2) {
                ProlookReversible.funcs.onSaveDesignSide1();
                return;
            }

            _.delay(ProlookSaveDesign.events.onClickSave, 500);
        });
    },

    addMaterialIdUrlParams: function() {
        var url = "?material_id=";

        // search for cart_item_id
        var urlParams = new URLSearchParams(location.search);
        var cartItemID = urlParams.get('cart_item_id');

        if (!_.contains([null, 'null', ''], cartItemID)) {
            url = "?cart_item_id=" + cartItemID + "&material_id=";
        }

        var materialId = ub.config.material_id;
            url += materialId.toString();

        if (typeof ub.config.savedDesignInfo === "object") {
            var type = ub.config.type;
            var materialName = ub.config.uniform_name;

            ub.funcs.pushState({
                data: 'my-saved-design',
                url: url
            });

            // prevent `Missing Material Name` in pdf STYLE NAME for saved design item
            ub.current_material.settings[type].material_name = materialName;
        }
    },

	redirectToCart: function() {
        var cartItemID = ub.user.cart_item_id || sessionStorage.getItem("cart_item_id");
        var url = `${location.origin}/hub?cart-item-id=${cartItemID}`;

        SessionFlash.set({
            status: "success",
            message: "Successfully updated design."
        });

        window.parent.onbeforeunload = null;
        window.parent.location.href = url;
        sessionStorage.clear();
        localStorage.clear();
	},

	errorNotification: function() {
        var Parent = window.parent;
        Parent.Loader.hide();
        UIkit.notification({
            message: "Something went wrong. Please try again.",
            status: 'danger',
            pos: 'top-right'
        });
    },

    onClickSave: function() {
        var onReversibleSide2 = _.isEqual(ub.config.isEmbedded, "1");
        var parentWindow = window.parent;

        // Save Part Information
        if (typeof PartInformation === "object") {
            let labels = ub.data.modifierLabels;
            
            if (QX7Rule.enabled) {
                labels = QX7Rule.ModifierLabel.getLabels();
            }

            PartInformation.setupPartInformation(labels, ub.current_material.settings);
        }

        ProlookSaveDesign.utilities.uploadTextShapeImages();
        ProlookSaveDesign.funcs.prepareThumbnails();
        ProlookSaveDesign.funcs.uploadThumbnails( function() {
            ProlookSaveDesign.funcs.saveDesign( function(response) {

                (onReversibleSide2) ? parentWindow.Loader.loading(6, 9) : parentWindow.Loader.loading(2, 9);

                if (typeof response.sd_id !== "undefined") {
                    var newSavedDesignId = response.sd_id;
                    var cartItemID = ub.user.cart_item_id;

                    if (cartItemID) {
                        ProlookSaveDesign.funcs.updateUniformDesign(newSavedDesignId);
                    } else {
                        ProlookSaveDesign.funcs.saveUniformDesign(newSavedDesignId);
                    }

                } else {
                    // quick fix only, still need to refactor this code logic
                    // load old saved designs (prolook legacy) then allow `save and continue` feature
                    var url = new URL(window.location.href);
                    var isLegacySavedDesign = (url.pathname.indexOf('-old') !== -1) ? true: false;

                    if (isLegacySavedDesign) {
                        var savedDesignID = undefined;

                        if (typeof ub.config.savedDesignInfo !== "undefined") {
                            // old saved design id
                            savedDesignID = ub.config.savedDesignInfo.savedDesignID;
                        }

                        ProlookSaveDesign.funcs.saveUniformDesign(savedDesignID);
                    } else {
                        ProlookSaveDesign.funcs.updateUniformDesign();
                    }
                }

            }, ProlookSaveDesign.events.errorNotification);
        }, ProlookSaveDesign.events.errorNotification);

        //remove isClickSaveAppSize flag when saving design
        localStorage.removeItem('isClickSaveAppSize');
    },

    hideSide1SaveButton: function() {
        var onSide1 = ub.config.isReversible === "1" && !ub.config.isEmbedded ? true : false;

        if (onSide1) {
            $("#save-and-continue").hide();
        }
    },

    showSide1SaveButton: function() {
        var onSide1 = ub.config.isReversible === "1" && !ub.config.isEmbedded ? true : false;
        var isCalledOnce = _.contains(ProlookSaveDesign.events.calledOnceFunctions, "showSide1SaveButton");

        if (!isCalledOnce) {
            if (onSide1) {
                $("#save-and-continue").fadeIn();
                ProlookSaveDesign.events.calledOnceFunctions.push('showSide1SaveButton');
            }
        }
    }
};

ProlookSaveDesign.funcs = {
    saveUniformDesign: function(saveDesignId) {
        var isReversible = _.isEqual(ub.config.isReversible, "1");
        var onSide2 = _.isEqual(ub.config.isEmbedded, "1");
        var parentWindow = window.parent;

        ProlookSaveDesign.funcs.addCartItem(saveDesignId, function(res) {
            var newCartItemId = res.new_cart_item_id;
            onSide2 ? parentWindow.Loader.loading(7, 9) : parentWindow.Loader.loading(3, 9);

            if(isReversible && !onSide2) {
                // set cart_item_id on session to be used by side2 later.
                sessionStorage.setItem("cart_item_id", newCartItemId);
                ProlookReversible.funcs.onSaveDesignSide2();
            } else {
                ub.user.cart_item_id = newCartItemId;
                ProlookSaveDesign.events.redirectToCart();
                parentWindow.Loader.completeloading();
            }

        }, ProlookSaveDesign.events.errorNotification);
    },

    updateUniformDesign: function(saved_design_id) {
        var isReversible = _.isEqual(ub.config.isReversible, "1");
        var onReversibleSide1 = _.isEqual(ub.config.isEmbedded, "");
        var onReversibleSide2 = _.isEqual(ub.config.isEmbedded, "1");
        var thisFuncs = ProlookSaveDesign.funcs;
        var thisEvents = ProlookSaveDesign.events;
        var parentWindow = window.parent;
        var savedDesignID = saved_design_id;

        if (typeof ub.config.savedDesignInfo !== "undefined") {
            savedDesignID = ub.config.savedDesignInfo.savedDesignID;
        }

        thisFuncs.updateCartStyleUrl(function(res) {
            thisFuncs.updateCartStyleId(function(res) {
                thisFuncs.updateCartAppSizes(function(res) {
                    (onReversibleSide2) ? parentWindow.Loader.loading(8, 9) : parentWindow.Loader.loading(4, 9);

                    thisFuncs.updateCartThumbnails(function(res) {
                        (onReversibleSide2) ? parentWindow.Loader.loading(9, 9) : parentWindow.Loader.loading(5, 9);

                        thisFuncs.updateCartDesignId(savedDesignID, function(res) {
                            if (isReversible && onReversibleSide1) {
                                ProlookReversible.funcs.onSaveDesignSide2();
                            } else {
                                thisEvents.redirectToCart();
                                parentWindow.Loader.completeloading();
                            }

                        }, thisEvents.errorNotification);
                    }, thisEvents.errorNotification);
                }, thisEvents.errorNotification);
            }, thisEvents.errorNotification);
        }, thisEvents.errorNotification);

        thisFuncs.updateCartRoster(function(res) {
            localStorage.removeItem('styleFromHub');
        });
    },

    // save to saved design (pl api) (old way)
    savedDesign: function(callback) {
        ProlookSaveDesign.utilities.uploadTextShapeImages();
        ProlookSaveDesign.funcs.prepareThumbnails();
        ProlookSaveDesign.funcs.uploadThumbnails( function() {
            ProlookSaveDesign.funcs.saveDesign(callback , ProlookSaveDesign.events.errorNotification);
        }, ProlookSaveDesign.events.errorNotification);
    },

    reversibleData: function(savedDesignId, side, otherSideId) {
        var prepareData = ProlookSaveDesign.funcs.prepareData();
        if (prepareData && prepareData.builderCustomizations) {
            prepareData.savedDesignId = savedDesignId;
            prepareData.builderCustomizations.reversible = {
                side: side,
                otherSideId: otherSideId,
            }
        }
        return prepareData;
    },

    prepareThumbnails: function() {
        ub.funcs.removeLocations();
        ub.funcs.deactivateMoveTool();

        ub.current_material.settings.thumbnails = {
            front_view  : "",
            back_view   : "",
            left_view   : "",
            right_view  : "",
            top_view  : "",
        };

        ub['front_view'].visible = true;
        ub['left_view'].visible  = true;
        ub['right_view'].visible = true;
        ub['back_view'].visible  = true;
        ub['top_view'].visible  = true;
    },

    prepareData: function() {
        ProlookSaveDesign.utilities.getPriceItemCode();
        ProlookSaveDesign.utilities.sortedModifierLabels();
        ProlookSaveDesign.utilities.setMaterialInfo();
        ProlookSaveDesign.utilities.clearCustomizationAppSizing();
        ProlookSaveDesign.utilities.generateStyleUrl();

        var brand = ub.config.brand;
        var brandID = ub.config.brand_id;
        var brandVersion = ub.config.brand_version;
        var material = ub.current_material.material;
        var builderCustomizations = ub.current_material.settings;
            builderCustomizations.item_id = material.item_id;

        var data = {
            userEmail: ub.user.email,
            userId: ub.user.id,
            materialId: material.id,
            materialName: material.name,
            sport: material.uniform_category,
            brand: brand,
            brand_id: brandID,
            brand_version: brandVersion,
            builderCustomizations: builderCustomizations,
            frontImage: builderCustomizations.thumbnails.front_view,
            backImage: builderCustomizations.thumbnails.back_view,
            leftImage: builderCustomizations.thumbnails.left_view,
            rightImage: builderCustomizations.thumbnails.right_view,
            topImage: builderCustomizations.thumbnails.top_view,
            // The session item `designTitle` and `designDescription` is set on savedOnSavedDesignPage().
            name: sessionStorage.getItem("designTitle") || "Design Title", // default when the design will not be saved on cart.
            notes: sessionStorage.getItem("designDescription") || "Description" // default when the design will not be saved on cart.
        };

        // Change the saved design name
        if(ub.user.cart_item_id) {
            // Applied when updating the saved design.
            var activeCart = CartInformation.events.activeCart;
            if (!_.isEmpty(activeCart)) {
                data.name = `${activeCart.name} ${material.name}`;
            }
        } else {
            // The `activeCartName` session item is set on saveOnCreatedCart() and savedOnSelectedCart().
            var activeCartName = sessionStorage.getItem("activeCartName");
            if(activeCartName) {
                data.name = `${activeCartName} ${material.name}`;
            }
        }

        if (typeof ub.config.savedDesignInfo !== 'undefined' && !_.isNull(ub.user.cart_item_id)) {
            delete data.user;
            delete data.material_name;
            data.savedDesignId = ub.config.savedDesignInfo.savedDesignID;
        }

        return data;
    },

    uploadThumbnails: function(callback, errorHandler) {
        var views = ub.views;

        _.each(views, function(view) {
            var perspective = view + "_view";
            var imageDataUrl = ub.getThumbnailImage(perspective);

            ProlookSaveDesign.prolookApi.uploadThumbnail(imageDataUrl, function(response) {
                if (response.success) {
                    ub.current_material.settings.thumbnails[perspective] = response.filename;

                    if (ub.funcs.thumbnailsUploaded()) {
                        callback();
                    }

                } else {
                    errorHandler(response);
                }
            }, errorHandler);
        });
    },

    saveDesign: function(callback, errorHandler) {
        var prepareData = ProlookSaveDesign.funcs.prepareData();
        var isSavedDesign = !_.isUndefined(ub.config.savedDesignInfo);
        var hasCartID = !_.isNull(ub.user.cart_item_id);
        var onCallback = function(response) {
            (!response.success) ? errorHandler(response) : callback(response);
        };

        if (isSavedDesign && hasCartID) {
            ProlookSaveDesign.prolookApi.updateDesign(prepareData, onCallback, errorHandler);
        } else {
            ProlookSaveDesign.prolookApi.saveDesign(prepareData, onCallback, errorHandler);
        }
    },

    cartItemLimitNotification: function(response) {
        Loader.endloading(function() {
             UIkit.notification({
                message: response.message,
                status: 'danger',
                pos: 'top-right',
                timeout: 10000
            });
        });
    },

    addCartItem: function(design_id, callback, errorHandler) {
        var cartItemID = sessionStorage.getItem("cart_item_id");
        var onReversibleSide2 = _.isEqual(ub.config.isEmbedded, "1");
        var requestData = {
            userId: ub.user.id,
            styleId: ub.config.material_id,
            styleName: ub.current_material.material.name,
            designId: design_id,
            styleUrl: ProlookSaveDesign.utilities.generateStyleUrl(),
            frontImage: ub.current_material.settings.thumbnails.front_view,
            backImage: ub.current_material.settings.thumbnails.back_view,
            leftImage: ub.current_material.settings.thumbnails.left_view,
            rightImage:ub.current_material.settings.thumbnails.right_view,
            topImage: ub.current_material.settings.thumbnails.top_view,
            builderCustomizations: ub.current_material.settings,
        };

        var onCallback = res => {
            !res.success ? ProlookSaveDesign.funcs.cartItemLimitNotification(res) : callback(res);
        };

        if (onReversibleSide2) {
            if (cartItemID) {
                ProlookSaveDesign.cartItemSide2Api.addItem(cartItemID, requestData, onCallback, errorHandler);
            } else {
                errorHandler();
            }
        } else {
            ProlookSaveDesign.cartItemApi.addItem(requestData, onCallback, errorHandler);
        }
    },

    updateCartStyleId: function(callback, errorHandler) {
        var cartItemID = ub.user.cart_item_id;
        var onReversibleSide2 = _.isEqual(ub.config.isEmbedded, "1");
        var styleId = ub.config.material_id;

        if (onReversibleSide2) {
            ProlookSaveDesign.cartItemSide2Api.updateStyleId(cartItemID, styleId, callback, errorHandler);
        } else {
            ProlookSaveDesign.cartItemApi.updateStyleId(cartItemID, styleId, callback, errorHandler);
        }
    },

    updateCartStyleUrl: function(callback, errorHandler) {
        var cartItemID = ub.user.cart_item_id;
        var styleUrl = ProlookSaveDesign.utilities.generateStyleUrl();
        var onReversibleSide2 = _.isEqual(ub.config.isEmbedded, "1");

        if (onReversibleSide2) {
            callback({
                success: true,
                message: "Style Url is not reversible side 2"
            });
            return undefined;
        }

        ProlookSaveDesign.cartItemApi.updateStyleUrl(cartItemID, styleUrl, callback, errorHandler);
    },

    updateCartThumbnails: function(callback, errorHandler) {
        var cartItemID = ub.user.cart_item_id;
        var onReversibleSide2 = _.isEqual(ub.config.isEmbedded, "1");
        var thumbnails = {
            "front": ub.current_material.settings.thumbnails.front_view,
            "back": ub.current_material.settings.thumbnails.back_view,
            "left": ub.current_material.settings.thumbnails.left_view,
            "right": ub.current_material.settings.thumbnails.right_view,
            "top": ub.current_material.settings.thumbnails.top_view
        }

        if (onReversibleSide2) {
            ProlookSaveDesign.cartItemSide2Api.updateThumbnails(cartItemID, thumbnails, callback, errorHandler);
        } else {
            ProlookSaveDesign.cartItemApi.updateThumbnails(cartItemID, thumbnails, callback, errorHandler);
        }
    },

    updateCartDesignId: function(design_id, callback, errorHandler) {
        var cartItemID = ub.user.cart_item_id;
        var builderCustomization = JSON.stringify(ub.current_material.settings);
        var onReversibleSide2 = _.isEqual(ub.config.isEmbedded, "1");
        var onCallback = function(response) {
            (!response.success) ? errorHandler(response) : callback(response);
        };

        if (onReversibleSide2) {
            ProlookSaveDesign.cartItemSide2Api.updateDesign(cartItemID, design_id, builderCustomization, onCallback, errorHandler);
        } else {
            ProlookSaveDesign.cartItemApi.updateDesign(cartItemID, design_id, builderCustomization, onCallback, errorHandler);
        }
    },

    updateCartAppSizes: function(callback, errorHandler) {
        var emptyAppSize = [];
        var cartItemID = ub.user.cart_item_id;
        var onReversibleSide2 = _.isEqual(ub.config.isEmbedded, "1");
        var onCallback = function(response) {
            (!response.success) ? errorHandler(response) : callback(response);
        };

        if (onReversibleSide2) {
            ProlookSaveDesign.cartItemSide2Api.updateApplicationSizes(cartItemID, emptyAppSize, onCallback, errorHandler);
        } else {
            ProlookSaveDesign.cartItemApi.updateApplicationSizes(cartItemID, emptyAppSize, onCallback, errorHandler);
        }
    },

    updateCartRoster: function(callback, errorHandler) {
        var styleFromHub = JSON.parse(localStorage.getItem('styleFromHub'));
        var cartItemID = ub.user.cart_item_id;
        var emptyRoster = [];

        var data = {
            item_name: ub.current_material.material.name,
        }

        var onCallback = function(response) {
            (!response.success) ? errorHandler(response) : callback(response);
        };

        if (styleFromHub) {
            ProlookSaveDesign.rosterApi.saveRoster(cartItemID, emptyRoster, onCallback, errorHandler);
            ProlookSaveDesign.cartApi.updateItemName(data, cartItemID, onCallback, errorHandler);
        }
    },

    triggerTeamFlagMirrorImage: function() {
        if(ub.config.sport === "Team Flag (Apparel)") {
            //clone the front view as a sprite and flip the sprite (TEAM FLAG);
            ub.funcs.teamFlagMirrorImage("save", function() {
                ub.status.fullView.setStatus(true);
                return undefined;
            });
        }
    }
};

ProlookSaveDesign.utilities = {
    showConflictColorModal: function() {
        var colorConflictApplication = ub.funcs.embellishmentsWithColorConflict(),
            colorConflictTextApplication = ub.funcs.textApplicationWithColorConflict(),
            colorConflictParts = ub.funcs.materialOptionsWithColorConflict(),
            embellishmentsData = [],
            textApplicationData = [],
            materialOptionsData = [];

        // Embellishment
        _.each(colorConflictApplication, function(embellishment) {
            var id = embellishment.applicationCode;
            var settingsObject = ub.funcs.getSettingsObject(id);
            var embellishmentObject = settingsObject.embellishment;
            var name = '#' + id + ' - ' + embellishmentObject.name;
                name = name.toUpperCase();
            var totalColorConflict =  _.size(embellishment.conflictColors);
                totalColorConflict = (totalColorConflict > 1) ? totalColorConflict + ' Conflict Colors' : totalColorConflict + ' Conflict Color';

            embellishmentsData.push({
                type: "embellishment",
                embellishments: embellishmentObject,
                name: name,
                totalColorConflict: totalColorConflict,
                id: id // app_id
            });
        });

        // Text Application
        _.each(colorConflictTextApplication, function(textApplication) {
            var id = textApplication.application_code;
            var settingsObject = ub.funcs.getSettingsObject(id);
            var mascotPattern = settingsObject.mascot_pattern;
            var name = '#' + id + ' - ' + mascotPattern.name;
                name = name.toUpperCase();
            var totalColorConflict = _.size(textApplication.conflict_colors);

            totalColorConflict = (totalColorConflict > 1) ?  totalColorConflict + ' Conflict Colors' : totalColorConflict + ' Conflict Color';

            textApplicationData.push({
                type: "text-application",
                appSettingsObject: mascotPattern,
                name: name,
                totalColorConflict: totalColorConflict,
                id: id // app_id
            });
        });

        // Material Options
        _.each(colorConflictParts, function(materialOption) {
            var partObject = materialOption.material_object.mascot_pattern,
                partCode = materialOption.material_object.code,
                modifier = _.find(ub.data.modifierLabels, {fullname: partCode}),
                totalColorConflict = _.size(materialOption.conflict_colors);

            totalColorConflict = (totalColorConflict > 1) ?  totalColorConflict + ' Conflict Colors' : totalColorConflict + ' Conflict Color';

            materialOptionsData.push({
                type: "material",
                name: modifier.name,
                totalColorConflict: totalColorConflict,
                materialObject: partObject,
                id: modifier.index// modifier_index
            });
        });

        var _html = ub.utilities.buildTemplateString('#m-embellishment-order-conflict-colors', {
            'embellishments': embellishmentsData,
            'textEmbellishments': textApplicationData,
            'materialEmbellishments': materialOptionsData
        });

        var dialog = bootbox.alert({ message: _html });
            dialog.modal('show');

        $('.fix-conflict').on('click', function() {
            var appOrMaterialID = $(this).data('id'),
                designID = $(this).data('design-id'),
                type = $(this).data('type'),
                EMBELLISHMENT_TYPE = "embellishment",
                TEXT_APPLICATION_TYPE = "text-application"
                MATERIAL_OPTION_TYPE = "material";

            dialog.modal('hide');
            ub.data.isEditing = true;

            if (type === EMBELLISHMENT_TYPE) {
                var applicationSettings = ub.funcs.getApplicationSettings(appOrMaterialID),
                    embellishment = applicationSettings.embellishment,
                    conflictingColors = ub.funcs.hasConflict(embellishment.design_details);

                InksoftMascot.funcs.onShowEditDesignConflict(designID, appOrMaterialID, function() {
                    InksoftMascot.uiHandler.renderConflictColors({
                        colors: conflictingColors._conflictColors
                    });
                    UIkit.modal("#inksoft-design-editor-modal-with-conflict").show();
                });
            } else if (type === MATERIAL_OPTION_TYPE) {
                var modifer = ub.funcs.getModifierByIndex(appOrMaterialID),
                    names = ub.funcs.ui.getAllNames(modifer.name),
                    materialSettingsObject = ub.funcs.getMaterialOptionSettingsObject(names[0].toTitleCase()),
                    conflictingColors = ub.funcs.hasConflict(materialSettingsObject.mascot_pattern.design_details);

                ub.partMascotAsPattern = true;
                ub.current_part = appOrMaterialID;
                InksoftMascot.funcs.onShowEditDesignConflict(designID, undefined, function() {
                    InksoftMascot.uiHandler.renderConflictColors({
                        colors: conflictingColors._conflictColors
                    });
                    UIkit.modal("#inksoft-design-editor-modal-with-conflict").show();
                });
            } else if (type === TEXT_APPLICATION_TYPE) {
                var applicationSettings = ub.funcs.getApplicationSettings(appOrMaterialID);
                var mascotPattern = applicationSettings.mascot_pattern;
                var conflictingColors = ub.funcs.hasConflict(mascotPattern.design_details);

                ub.applicationMascotAsPattern = true;

                InksoftMascot.funcs.onShowEditDesignConflict(designID, appOrMaterialID, function() {
                    InksoftMascot.uiHandler.renderConflictColors({
                        colors: conflictingColors._conflictColors
                    });
                    UIkit.modal("#inksoft-design-editor-modal-with-conflict").show();
                });
            }
        });
    },

    generateStyleUrl: function() {
        var material = ub.current_material.material;
        var gender = material.gender.toLowerCase();
        var sportAlias = ub.data.urlAlias.getSportCode(ub.config.sport);
        var blockPattern = material.block_pattern;
            blockPattern = blockPattern.replace(/\s+/g, '-');
            blockPattern = blockPattern.toLowerCase();
        var styleUrl = "/styles/" + gender + "/" + sportAlias + "/" + blockPattern;

        // Save BC
        ub.current_material.settings.styleUrl = styleUrl;

        return styleUrl;
    },

    getPriceItemCode: function() {
        var obj1 = ub.current_material.settings;
        var parsedPricingTable = ub.current_material.material.parsedPricingTable;
        var _adultPriceItem,
            _youthPriceItem,
            isAdultCodeVisible = false,
            isYouthCodeVisible = false;

        if(parsedPricingTable && !_.isEmpty(parsedPricingTable.properties)) {
            _adultPriceItem = _.pluck(parsedPricingTable.properties.adult, 'price_item');
            _youthPriceItem = _.pluck(parsedPricingTable.properties.youth, 'price_item');

            isAdultCodeVisible = (_adultPriceItem.length > 0) ? true : false;
            isYouthCodeVisible = (_youthPriceItem.length > 0) ? true : false;
        }

        _adult_price_item = _.uniq(_adultPriceItem);
        _youth_price_item = _.uniq(_youthPriceItem);

        var obj2 = {
            priceItemCode : {
                youth: { "value": _youth_price_item, "visibility": isYouthCodeVisible },
                adult: { "value": _adult_price_item, "visibility": isAdultCodeVisible },
            }
        }

        $.extend(obj1, obj2);
    },

    sortedModifierLabels: function() {
        var settings = ub.current_material.settings;
        var modifierLabels = ub.data.modifierLabels;
            modifierLabels = _.sortBy(modifierLabels, 'intGroupID');
        var mappedmodifierLabels = [];

        _.each(modifierLabels, function(material) {
            var type = ub.config.type;
            var materials_options = ub.current_material.settings[type];
            var option = _.find(materials_options, {code: material.fullname});

            if (option) {
                if (typeof option.colorObj.color_code !== "undefined") {
                    material.color_code = option.colorObj.color_code;
                }
                
                if (typeof option.colorObj.name !== "undefined"){
                    material.color_name = option.colorObj.name;
                }

                if (typeof option.pattern !== "undefined") {
                    if (typeof option.pattern.pattern_obj !== "undefined") {
                        if (typeof option.pattern.pattern_obj.layers !== "undefined" && _.size(option.pattern.pattern_obj.layers) > 0) {
                            var layers = option.pattern.pattern_obj.layers;

                            _.each(layers, function(layer) {
                                var color = _.find(ub.data.colors, {color_code: layer.color_code});

                                if (typeof color !== "undefined") {
                                    layer.colorObj = color;
                                }
                            });
                        }

                        material.pattern = option.pattern.pattern_obj;
                    }
                }

                if (typeof option.mascot_pattern !== "undefined"){
                    material.mascot_pattern = option.mascot_pattern;
                }
        
                if (typeof option.mascot_pattern_settings !== "undefined"){
                    material.mascot_pattern_settings = option.mascot_pattern_settings;
                }
            }

            mappedmodifierLabels.push(material);
        });

        settings.sml = mappedmodifierLabels;
    },

    setMaterialInfo: function() {
        var materialInfo = {
            material_id: ub.config.material_id,
            type: ub.config.type,
            block_pattern: ub.config.blockPattern,
            option: ub.config.option,
            uniform_application_type: ub.config.uniform_application_type,
            uniform_brand: ub.config.uniform_brand,
            uniform_name: ub.config.uniform_name,
            uniform_category: ub.config.sport,
            gender: ub.config.gender.toTitleCase(),
            priceItemCode: ub.config.priceItemCode
        };

        ub.current_material.settings.material = materialInfo;
    },

    uploadTextShapeImages: function() {
        const TEXT_SHAPE = "text_shape";
        var textShapesApps = _.filter(ub.current_material.settings.applications, (app) => {
            return app.text_type && app.text_type === TEXT_SHAPE;
        });

        _.each(textShapesApps, (app) => {
            if(app.embellishment && !_.isEmpty(app.embellishment)) {
                var embellishment = app.embellishment;

                if(embellishment.png_filename) {
                    ProlookSaveDesign.prolookApi.uploadThumbnail(embellishment.png_filename, (res) =>  {
                        embellishment.png_image = res.filename;
                    }, (errorResponse) => {
                        console.error(errorResponse);
                    })
                }
            }
        })

    },

    clearCustomizationAppSizing: function() {
        let customizeSettings = ub.current_material.settings
        _.has(customizeSettings, "applicationSizing") && delete customizeSettings.applicationSizing;

        if (_.size(customizeSettings.applications) > 0) {
            _.each(customizeSettings.applications, (app) => {
                _.has(app, "applicationSize") && delete app.applicationSize;
                _.has(app, "notes") && delete app.notes;
            });
        }
    }
}

